import { useCallback, useState } from "react";

import { Dialog, DialogContent } from "@/components/ui/dialog/dialog";

import { RoomPriceRankRoomList } from "./rooms";
import { RoomPriceRankStopSell } from "./stop-sell";

import type { RoomPriceRankItemType } from "../../../../type";

type Props = {
	priceRankItem: RoomPriceRankItemType;
	onSetIsStopSelling: (input: boolean | undefined) => void;
	onSetPriceAmount: (roomID: string, amount: number | undefined, adultNum: number) => void;
	onSetRoomPriceRankItem: (value: RoomPriceRankItemType) => void;

	// render props パターン
	dialogTriggerChildren: (props: { open: boolean; onChangeOpen: (open: boolean) => void }) => React.ReactNode;
};

export const DialogEditPriceRank = ({
	priceRankItem,
	onSetIsStopSelling,

	onSetPriceAmount,
	onSetRoomPriceRankItem,

	dialogTriggerChildren,
}: Props) => {
	const [open, setOpen] = useState(false);
	const onChangeOpen = useCallback((input: boolean) => {
		setOpen(input);
	}, []);

	return (
		<div className={"px-2 pb-3 pt-7"}>
			<Dialog open={open} onOpenChange={setOpen}>
				{/* ダイアログ開閉のトリガーとなるコンポーネント */}
				{dialogTriggerChildren({ open, onChangeOpen })}

				{/* ダイアログの中身 */}
				<DialogContent className="max-h-[85%] max-w-[95%] space-y-6 overflow-y-auto laptop:max-h-[70%] laptop:max-w-[70%]">
					<div>
						<h4 className="text-lg font-semibold">「{priceRankItem.name.value}」の部屋料金設定</h4>
					</div>

					<div className="ml-0 space-y-6 laptop:ml-4">
						<RoomPriceRankStopSell priceRankItem={priceRankItem} onSetIsStopSelling={onSetIsStopSelling} />

						<RoomPriceRankRoomList
							onSetPriceAmount={onSetPriceAmount}
							priceRankItem={priceRankItem}
							onSetRoomPriceRankItem={onSetRoomPriceRankItem}
						/>
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
};

DialogEditPriceRank.displayName = "DialogEditPriceRank";
